<template>
	<div class="popup" @click="close">
		<div class="popup-p"></div>
		<img src="../../assets/images/vip/instructions.png" alt="">
	</div>
</template>
<script>
	export default {
		data() {
			return {}
		},
		methods: {
			close() {
				this.$emit('closeShare')
			}
		}
	}
</script>
<style lang="less" scoped>
	.popup {
		display: flex;
		align-items: center;
		justify-content: center;

		.popup-p {
			position: fixed;
			background: #000000ad;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			z-index: 9;
			transition: all 0.3s;
		}

		img {
			width: 80%;
			position: absolute;
			top: 100px;
			z-index: 9;
		}
	}
</style>
